"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NBaseIcon = void 0;
var Icon_1 = require("./src/Icon");
Object.defineProperty(exports, "NBaseIcon", { enumerable: true, get: function () { return __importDefault(Icon_1).default; } });
